/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_Dtos_Totp_ParticipantTotpVerificationRequestDto } from '../models/Wealthlane_Dtos_Totp_ParticipantTotpVerificationRequestDto';
import type { Wealthlane_Dtos_Totp_ParticipantTotpVerificationResponseDto } from '../models/Wealthlane_Dtos_Totp_ParticipantTotpVerificationResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantTotpVerificationService {

    /**
     * @param requestBody
     * @returns Wealthlane_Dtos_Totp_ParticipantTotpVerificationResponseDto OK
     * @throws ApiError
     */
    public static postApiIdentityApiParticipantTotpVerify(
        requestBody?: Wealthlane_Dtos_Totp_ParticipantTotpVerificationRequestDto,
    ): CancelablePromise<Wealthlane_Dtos_Totp_ParticipantTotpVerificationResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/identity/api/participant/totp/verify',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
